export default __webpack_public_path__ + "static/media/LONG.4f2d6201.png";